import React, { Fragment, useRef, useState } from 'react'
import mammoth from "mammoth"
import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './syllabus-upload-planner.css'

const SyllabusUploadPlanner = (props) => {

  const fileInputRef = useRef(null)
  const [fileName, setFileName] = useState('')
  const [selectedFile, setSelectedFile] = useState(null)
const [plan, setPlan] = useState(null)
const [loading, setLoading] = useState(false)
const [error, setError] = useState('')

  const openFilePicker = () => fileInputRef.current?.click()

 const onFileSelected = (e) => {
  const file = e.target.files?.[0]
  if (!file) return

  setSelectedFile(file)
  setFileName(file.name)

  setPlan(null)
  setError('')
};
async function fileToText(file) {
  const name = (file?.name || '').toLowerCase()

  if (name.endsWith('.txt')) return await file.text()

  if (name.endsWith('.docx')) {
    const arrayBuffer = await file.arrayBuffer()
    const result = await mammoth.extractRawText({ arrayBuffer })
    return result.value || ''
  }

  if (name.endsWith('.pdf')) {
    throw new Error('PDF parsing not enabled yet — upload a DOCX for now.')
  }

  throw new Error('Unsupported file type. Upload DOCX or TXT.')
}

async function onGeneratePlan() {
  try {
    setError('')
    if (!selectedFile) {
      setError('Please select a syllabus file first.')
      return
    }

    setLoading(true)

    const syllabusText = await fileToText(selectedFile)

    // TEMP: for now, just show the extracted text as the "plan"
    // so you know parsing works before adding an API.
    setPlan({ extractedTextPreview: syllabusText.slice(0, 1500) })
  } catch (e) {
    setError(e?.message || 'Something went wrong')
  } finally {
    setLoading(false)
  }
}
 return (   
    <div className="syllabus-upload-planner-container1">
      <Helmet>
        <title>Syllabus-Upload-Planner - Super Sizzling Curlew</title>
        <meta
          property="og:title"
          content="Syllabus-Upload-Planner - Super Sizzling Curlew"
        />
        <link
          rel="canonical"
          href="https://super-sizzling-curlew-lvmy3i.teleporthq.site/syllabus-upload-planner"
        />
      </Helmet>
      <Navigation
        text={
          <Fragment>
            <span className="syllabus-upload-planner-text10">More</span>
          </Fragment>
        }
      ></Navigation>
      <section className="planner-hero">
        <div className="planner-hero-wrapper">
          <div className="planner-hero-main">
            <h1 className="syllabus-upload---planner-hero-title hero-title">
              <span>
                {' '}
                SylliPlan: Your Semester,
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <br></br>
              <span>
                {' '}
                Auto-Scheduled.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h1>
            <p className="hero-subtitle">
              Upload your syllabus and let our AI generate a complete daily
              study plan with all your assignments, tasks, and deadlines in
              seconds.
            </p>
          </div>
          <div className="planner-hero-bento">
            <div className="bento-cell upload-zone">
              <div className="upload-content">
                <div className="icon-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                    >
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2m-5-10v6"></path>
                      <path d="M9.5 13.5L12 11l2.5 2.5"></path>
                    </g>
                  </svg>
                </div>
                <p className="section-content">
                  Drag &amp; drop syllabus PDF or DOCX
                </p>
                <button
  type="button"
  className="btn btn-primary btn-sm"
  onClick={openFilePicker}
>
  Select File
</button>

<input
  ref={fileInputRef}
  type="file"
  accept=".pdf,.doc,.docx,.txt"
  onChange={onFileSelected}
  style={{ display: 'none' }}
/>

{fileName ? <div style={{ marginTop: 8 }}>Selected: {fileName}</div> : null}
              </div>
            </div>
            <div className="bento-cell quick-settings">
              <h3 className="bento-title">Semester Dates</h3>
              <div className="settings-group">
                <input
                  type="date"
                  aria-label="Start Date"
                  value="2026-01-15"
                  className="form-input"
                />
                <input
                  type="date"
                  aria-label="End Date"
                  value="2026-05-20"
                  className="form-input"
                />
              </div>
            </div>
            <div className="bento-cell study-days">
              <h3 className="bento-title">Preferred Study Days</h3>
              <div className="day-chips">
                <span className="chip active">M</span>
                <span className="chip active">T</span>
                <span className="chip active">W</span>
                <span className="chip active">T</span>
                <span className="chip active">F</span>
                <span className="chip">S</span>
                <span className="chip">S</span>
              </div>
            </div>
            <div className="bento-cell action-cell">
              <button
  type="button"
  className="full-width btn btn-accent btn-lg"
  onClick={onGeneratePlan}
  disabled={loading}
    >
                <span>
                  {' '}
                  Generate Plan
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20 6L9 17l-5-5"
                  ></path>
                </svg>
              </button>
              <p className="small section-content">AI-Powered Extraction</p>
            </div>
          </div>
        </div>
      </section>
      <section className="how-it-works">
        <div className="container-inner">
          <h2 className="text-center section-title">How It Works</h2>
          <div className="syllabus-upload---planner-process-steps">
            <div className="process-step">
              <div className="syllabus-upload---planner-step-number">
                <span>01</span>
              </div>
              <div className="syllabus-upload---planner-step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 3v12m5-7l-5-5l-5 5m14 7v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Parse Syllabus</h3>
              <p className="section-content">
                Upload your course documents. Our AI scans for grading scales,
                dates, and requirements.
              </p>
            </div>
            <div className="process-step">
              <div className="syllabus-upload---planner-step-number">
                <span>02</span>
              </div>
              <div className="syllabus-upload---planner-step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Extract Tasks</h3>
              <p className="section-content">
                Assignments, readings, and exams are automatically extracted and
                categorized by weight.
              </p>
            </div>
            <div className="process-step">
              <div className="syllabus-upload---planner-step-number">
                <span>03</span>
              </div>
              <div className="syllabus-upload---planner-step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Schedule Plan</h3>
              <p className="section-content">
                Tasks are distributed across your semester based on your
                availability and study habits.
              </p>
            </div>
            <div className="process-step">
              <div className="syllabus-upload---planner-step-number">
                <span>04</span>
              </div>
              <div className="syllabus-upload---planner-step-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M11 10v4h4"></path>
                    <path d="m11 14l1.535-1.605a5 5 0 0 1 8 1.5M16 2v4m5 12l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                    <path d="M21 22v-4h-4m4-9.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3M3 10h4m1-8v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Sync Calendar</h3>
              <p className="section-content">
                Export your daily plan to Google Calendar, Outlook, or Apple
                Calendar with one click.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="smart-features">
        <div className="container-inner">
          <div className="features-header">
            <h2 className="section-title">Smart Scheduling Features</h2>
            <p className="section-content">
              Everything you need to stay ahead of your coursework without the
              manual planning stress.
            </p>
          </div>
          <div className="syllabus-upload---planner-features-grid">
            <div className="syllabus-upload---planner-feature-card">
              <div className="feature-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 5H3m13 7H3m8 7H3m12-1l2 2l4-4"
                  ></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Due-Date Detection</h3>
              <p className="section-content">
                Our AI identifies specific deadlines and exam dates hidden in
                tables and text blocks automatically.
              </p>
            </div>
            <div className="syllabus-upload---planner-feature-card">
              <div className="feature-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M12 18V5m3 8a4.17 4.17 0 0 1-3-4a4.17 4.17 0 0 1-3 4m8.598-6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"></path>
                    <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77"></path>
                    <path d="M18 18a4 4 0 0 0 2-7.464"></path>
                    <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"></path>
                    <path d="M6 18a4 4 0 0 1-2-7.464"></path>
                    <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Priority Balancing</h3>
              <p className="section-content">
                Heavier assignments get more prep time. The AI balances your
                workload to prevent &quot;hell weeks.&quot;
              </p>
            </div>
            <div className="syllabus-upload---planner-feature-card">
              <div className="feature-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                    <path d="M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Custom Study Blocks</h3>
              <p className="section-content">
                Tell us when you work best. SylliPlan fits your academic life
                around your actual life.
              </p>
            </div>
            <div className="syllabus-upload---planner-feature-card">
              <div className="feature-icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                  >
                    <path d="M11 10v4h4"></path>
                    <path d="m11 14l1.535-1.605a5 5 0 0 1 8 1.5M16 2v4m5 12l-1.535 1.605a5 5 0 0 1-8-1.5"></path>
                    <path d="M21 22v-4h-4m4-9.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3M3 10h4m1-8v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Live Calendar Sync</h3>
              <p className="section-content">
                Changes made in SylliPlan reflect instantly on your phone&apos;s
                native calendar app.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="semester-timeline">
        <div className="timeline-wrapper">
          <h2 className="text-center section-title">
            Sample Semester Timeline
          </h2>
          <div className="syllabus-upload---planner-timeline-scroll-container">
            <div className="timeline-track">
              <div className="timeline-item">
                <div className="timeline-marker">
                  <span>Week 01</span>
                </div>
                <div className="timeline-card">
                  <span className="milestone-tag">Onboarding</span>
                  <h4 className="section-subtitle">Syllabus Upload</h4>
                  <p className="section-content">
                    All courses imported. Daily study habits established in the
                    AI engine.
                  </p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-marker">
                  <span>Week 04</span>
                </div>
                <div className="timeline-card">
                  <span className="milestone-tag secondary">Exam Prep</span>
                  <h4 className="section-subtitle">Midterm Phase 1</h4>
                  <p className="section-content">
                    AI schedules 30-min daily review blocks for Calculus and
                    History.
                  </p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-marker">
                  <span>Week 08</span>
                </div>
                <div className="timeline-card">
                  <span className="milestone-tag accent">Project</span>
                  <h4 className="section-subtitle">Term Paper Draft</h4>
                  <p className="section-content">
                    Milestones generated for research, drafting, and final
                    citations.
                  </p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-marker">
                  <span>Week 12</span>
                </div>
                <div className="timeline-card">
                  <span className="milestone-tag">Finals</span>
                  <h4 className="section-subtitle">The Final Push</h4>
                  <p className="section-content">
                    Automatic priority shift to high-weight exams and final
                    submissions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="quick-demo">
        <div className="container-inner">
          <div className="demo-card">
            <div className="demo-info">
              <h2 className="section-title">See SylliPlan in Action</h2>
              <p className="section-content">
                Watch how we transform a messy 12-page PDF into a streamlined,
                actionable semester schedule in under 60 seconds.
              </p>
              <ul className="demo-list">
                <li className="demo-list-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>Instant Extraction</span>
                </li>
                <li className="demo-list-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M20 6L9 17l-5-5"
                    ></path>
                  </svg>
                  <span>Dynamic Adjustments</span>
                </li>
              </ul>
            </div>
            <div className="video-container">
              <video
                poster="https://images.pexels.com/videos/5527596/pictures/preview-0.jpg"
                controls="true"
                src="https://videos.pexels.com/video-files/5527596/5527596-hd_1280_720_25fps.mp4"
                className="demo-video"
              ></video>
            </div>
          </div>
        </div>
      </section>
      <section className="impact-stats">
        <div className="container-inner">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-value">
                <span>40+</span>
              </div>
              <div className="stat-label">
                <span>Hours Saved / Semester</span>
              </div>
              <p className="section-content">
                Students spend less time planning and more time actually
                learning.
              </p>
            </div>
            <div className="stat-item">
              <div className="stat-value">
                <span>92%</span>
              </div>
              <div className="stat-label">
                <span>Completion Rate</span>
              </div>
              <p className="section-content">
                Assignments submitted on or before the due date for our active
                users.
              </p>
            </div>
            <div className="stat-item">
              <div className="stat-value">
                <span>0.4</span>
              </div>
              <div className="stat-label">
                <span>GPA Improvement</span>
              </div>
              <p className="section-content">
                Average increase in academic performance after one semester of
                use.
              </p>
            </div>
            <div className="stat-item">
              <div className="stat-value">
                <span>100k</span>
              </div>
              <div className="stat-label">
                <span>Tasks Scheduled</span>
              </div>
              <p className="section-content">
                Powering the academic success of students across 500+
                universities.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="testimonials">
        <div className="testimonials-carousel-wrapper">
          <h2 className="text-center section-title">Student Success Stories</h2>
          <div className="carousel-track">
            <div className="syllabus-upload---planner-testimonial-card">
              <div className="quote-icon">
                <span>&quot;</span>
              </div>
              <p className="italic section-content">
                &quot;SylliPlan literally saved my semester. I used to spend the
                first week of classes stressed out just trying to organize my
                calendar. Now, it takes 30 seconds.&quot;
              </p>
              <div className="syllabus-upload---planner-student-info">
                <div className="student-meta">
                  <strong>Sarah J.</strong>
                  <span>Sophomore, Engineering</span>
                </div>
              </div>
            </div>
            <div className="syllabus-upload---planner-testimonial-card">
              <div className="quote-icon">
                <span>&quot;</span>
              </div>
              <p className="italic section-content">
                &quot;The AI study tool is a game changer. It breaks down my
                massive term papers into small, manageable daily tasks. No more
                all-nighters!&quot;
              </p>
              <div className="syllabus-upload---planner-student-info">
                <div className="student-meta">
                  <strong>Marcus T.</strong>
                  <span>Senior, Pre-Med</span>
                </div>
              </div>
            </div>
            <div className="syllabus-upload---planner-testimonial-card">
              <div className="quote-icon">
                <span>&quot;</span>
              </div>
              <p className="italic section-content">
                &quot;I never miss a reading assignment anymore. The sync to my
                Google Calendar keeps me on track even when I&apos;m on the
                go.&quot;
              </p>
              <div className="syllabus-upload---planner-student-info">
                <div className="student-meta">
                  <strong>Elena R.</strong>
                  <span>Freshman, Psychology</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="syllabus-upload---planner-cta-section">
        <div className="container-inner">
          <div className="cta-content">
            <h2 className="section-title">Ready to Own Your Semester?</h2>
            <p className="section-content">
              Stop manual scheduling. Start academic winning. Join thousands of
              students using AI to master their time.
            </p>
            <div className="cta-actions">
              <button id="openCtaModal" className="btn btn-primary btn-xl">
                Get Started Now
              </button>
              <button className="btn btn-xl btn-outline">View Pricing</button>
            </div>
          </div>
        </div>
        <dialog id="ctaModal" className="modal-dialog">
          <div className="modal-inner">
            <button
              id="closeCtaModal"
              aria-label="Close"
              className="modal-close"
            >
              &amp;times;
            </button>
            <h2 className="section-title">Start Your Plan</h2>
            <p className="section-content">
              Upload your first syllabus to see the magic happen. No credit card
              required for your first course.
            </p>
            <form
              action="#"
              method="POST"
              data-form-id="2b86d832-3a29-4661-abd7-936c8016fff4"
              className="cta-form"
            >
              <div className="form-group">
                <label htmlFor="email" className="section-content">
                  University Email
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="student@university.edu"
                  required="true"
                  name="textinput"
                  data-form-field-id="email"
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <label htmlFor="syllabus" className="section-content">
                  Upload Syllabus
                </label>
                <input
                  type="file"
                  id="syllabus"
                  required="true"
                  name="textinput"
                  data-form-field-id="syllabus"
                  className="form-input"
                />
              </div>
              <button
                type="submit"
                id="thq_button_zDeE"
                name="button"
                data-form-field-id="thq_button_zDeE"
                className="full-width btn btn-accent btn-lg"
              >
                Generate My Schedule
              </button>
            </form>
            <p className="small text-center section-content">
              By continuing, you agree to our Terms of Service.
            </p>
          </div>
        </dialog>
      </section>
      <div className="syllabus-upload-planner-container2">
        <div className="syllabus-upload-planner-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="syllabus-upload-planner-container4">
        <div className="syllabus-upload-planner-container5">
          <Script
            html={`<script defer data-name="sylliplan-logic">
(function(){
  const modal = document.getElementById("ctaModal")
  const openBtn = document.getElementById("openCtaModal")
  const closeBtn = document.getElementById("closeCtaModal")

  if (openBtn && modal) {
    openBtn.addEventListener("click", () => {
      modal.showModal()
    })
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener("click", () => {
      modal.close()
    })
  }

  if (modal) {
    modal.addEventListener("click", (e) => {
      if (e.target === modal) {
        modal.close()
      }
    })
  }

  const chips = document.querySelectorAll(".chip")
  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      chip.classList.toggle("active")
    })
  })

  const generateBtn = document.querySelector(".action-cell .btn")
  if (generateBtn) {
    generateBtn.addEventListener("click", () => {
      generateBtn.textContent = "Analyzing Syllabus..."
      generateBtn.style.opacity = "0.8"
      setTimeout(() => {
        generateBtn.textContent = "Plan Generated!"
        generateBtn.classList.remove("btn-accent")
        generateBtn.style.backgroundColor = "#2ecc71"
      }, 2000)
    })
  }

  const observerOptions = {
    threshold: 0.1,
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  document.querySelectorAll(".feature-card, .stat-item, .process-step").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "all 0.6s ease-out"
    observer.observe(el)
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default SyllabusUploadPlanner
